import React from 'react';

const SearchBar = props => {
  return (
    <form className="search-bar--form" onReset={props.onFormReset} onSubmit={props.onSubmit}>
      <div className="search-bar--wrapper">
        <label className="search-bar--label" htmlFor="search-bar">
          <input
            className="site-search-search-bar"
            placeholder={props.placeholderText}
            onChange={props.onInputChange}
            id="search-bar"
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            width="24"
            className="desktop-only"
          >
            <path d="M18.9 20.3 13.3 14.7Q12.55 15.3 11.575 15.65Q10.6 16 9.5 16Q6.775 16 4.888 14.113Q3 12.225 3 9.5Q3 6.775 4.888 4.887Q6.775 3 9.5 3Q12.225 3 14.113 4.887Q16 6.775 16 9.5Q16 10.6 15.65 11.575Q15.3 12.55 14.7 13.3L20.325 18.925Q20.6 19.2 20.6 19.6Q20.6 20 20.3 20.3Q20.025 20.575 19.6 20.575Q19.175 20.575 18.9 20.3ZM9.5 14Q11.375 14 12.688 12.688Q14 11.375 14 9.5Q14 7.625 12.688 6.312Q11.375 5 9.5 5Q7.625 5 6.312 6.312Q5 7.625 5 9.5Q5 11.375 6.312 12.688Q7.625 14 9.5 14Z" />
          </svg>
        </label>
        <label
          className="mobile-submit-button--label mobile-only"
          htmlFor="mobile-submit-button"
        >
          <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
            <path d="M18.9 20.3 13.3 14.7Q12.55 15.3 11.575 15.65Q10.6 16 9.5 16Q6.775 16 4.888 14.113Q3 12.225 3 9.5Q3 6.775 4.888 4.887Q6.775 3 9.5 3Q12.225 3 14.113 4.887Q16 6.775 16 9.5Q16 10.6 15.65 11.575Q15.3 12.55 14.7 13.3L20.325 18.925Q20.6 19.2 20.6 19.6Q20.6 20 20.3 20.3Q20.025 20.575 19.6 20.575Q19.175 20.575 18.9 20.3ZM9.5 14Q11.375 14 12.688 12.688Q14 11.375 14 9.5Q14 7.625 12.688 6.312Q11.375 5 9.5 5Q7.625 5 6.312 6.312Q5 7.625 5 9.5Q5 11.375 6.312 12.688Q7.625 14 9.5 14Z" />
          </svg>
          <input
            className="mobile-submit-button"
            id="mobile-submit-button"
            type="submit"
            value=""
          />
        </label>
        <label className="clear-button--label hidden" htmlFor="clear-button">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 0 24 24"
            width="24px"
            fill="#6b7480"
          >
            <path d="M0 0h24v24H0V0z" fill="none" opacity=".87" />
            <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm4.3 14.3c-.39.39-1.02.39-1.41 0L12 13.41 9.11 16.3c-.39.39-1.02.39-1.41 0-.39-.39-.39-1.02 0-1.41L10.59 12 7.7 9.11c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0L12 10.59l2.89-2.89c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41L13.41 12l2.89 2.89c.38.38.38 1.02 0 1.41z" />
          </svg>
          <input
            id="clear-button"
            className="clear-button styleless-button"
            type="reset"
            value=""
          />
        </label>
      </div>
      <label htmlFor="submit" className="desktop-only">
        <input
          id="submit"
          className="base-button seafoam submit-button"
          type="submit"
          value={props.searchButtonText}
        />
      </label>
    </form>
  );
};

export default SearchBar;
